import type { Transaction } from 'dexie';
import type { Item } from '../../models';
import { generateSearchTokens } from '../../transformers';

export const schemaV3 = {
    taxes: 'id, name, value, deleted, [id+deleted]',
    paymentMethods:
        'id, name, type, paymentMethodIndex, deleted, enabled, [id+deleted]',
    staff: 'id, authUserId, role, deleted, registerPin, [registerPin+deleted], [id+deleted]',

    items: 'id, name, itemType, categoryId, measurementUnitId, isActive, [id+isActive], nameLower, *searchTokens',
    itemVariants:
        'id, name, sku, barcode, itemPriceType, itemId, deleted, [id+deleted]',
    itemVariantCompositions: 'id, variantId, deleted, [id+deleted]',

    categories: 'id, name, deleted, [id+deleted]',
    measurementUnits: 'id, name, deleted, [id+deleted]',
};

export async function v3Upgrade(transaction: Transaction) {
    return transaction
        .table('items')
        .toCollection()
        .modify((item: Item) => {
            item.nameLower = item.name.toLowerCase();
            item.searchTokens = generateSearchTokens(item.name);
        });
}
